import { fetchWithAdmin } from './fetchHelper';

/** Settings → Ad Campaigns. Secrets never come back: of Meta's token only
 *  whether one is set and its last four characters; of Google's service account
 *  key only whether one is set and the account's email. */
export interface AdCampaignSettings {
  meta: {
    enabled: boolean;
    datasetId: string;
    hasAccessToken: boolean;
    accessTokenLast4?: string;
    testEventCode: string;
    graphVersion: string;
  };
  google: GoogleAdsSettings;
  defaultGraphVersion: string;
  updatedAt?: string;
  updatedBy?: string;
}

export interface GoogleAdsSettings {
  enabled: boolean;
  customerId: string;
  loginCustomerId: string;
  conversionActions: { SecondSimulation: string; CompleteRegistration: string };
  hasServiceAccountKey: boolean;
  /** The account to add as a user in Google Ads. */
  serviceAccountEmail?: string;
  validateOnly: boolean;
  /** For the campaign sync script, not for conversions. Write-only. */
  hasDeveloperToken: boolean;
  developerTokenLast4?: string;
}

/** One campaign × ad, as its clicks named it. No `campaign`: the ad was not tagged. */
export interface AdCampaignRow {
  campaign?: string;
  content?: string;
  clicks: number;
  secondSimulation: number;
  signedUp: number;
  lastClickAt?: string;
}

export interface AdCampaignSettingsUpdate {
  meta?: {
    enabled: boolean;
    datasetId: string;
    testEventCode: string;
    graphVersion: string;
    /** Omit to keep the stored token; '' clears it; anything else replaces it. */
    accessToken?: string;
  };
  google?: {
    enabled: boolean;
    customerId: string;
    loginCustomerId: string;
    conversionActions: { SecondSimulation: string; CompleteRegistration: string };
    validateOnly: boolean;
    /** Omit to keep the stored key; '' clears it; anything else replaces it. */
    serviceAccountKey?: string;
    /** Omit to keep; '' clears; anything else replaces. */
    developerToken?: string;
  };
}

export const adCampaignSettingsApi = {
  get: () => fetchWithAdmin<AdCampaignSettings>('/console/settings/ad-campaigns'),
  update: (body: AdCampaignSettingsUpdate) =>
    fetchWithAdmin<AdCampaignSettings>('/console/settings/ad-campaigns', { method: 'PUT', body: JSON.stringify(body) }),
  /** Campaigns and ads that clicks have named in the last `days` (max 90). */
  campaigns: (days: number) =>
    fetchWithAdmin<{ days: number; campaigns: AdCampaignRow[] }>(`/console/settings/ad-campaigns/campaigns?days=${days}`),
  sendTest: () =>
    fetchWithAdmin<{ ok: boolean; message: string }>('/console/settings/ad-campaigns/test', { method: 'POST' }),
  /** Google validates one event per action; nothing is recorded. */
  sendGoogleTest: () =>
    fetchWithAdmin<{ ok: boolean; message: string }>('/console/settings/ad-campaigns/test-google', { method: 'POST' }),
};
